import { useRouter } from "src/lib/react-router/useRouter.ts";
import type { DataGridProps } from "src/components/DataGrid/DataGrid.tsx";
import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import { replacePathParams } from "@exonn/utils";
import type { BankTransactionResource } from "@exonn/js-sdk";
// import { createResourceStorageKeys } from "src/framework/createResourceStorageKeys.ts";
// import { memoryStorageDriver } from "src/storage/memoryStorage.driver.ts";
import { CreateAccountingPostingFormSearchParams } from "src/admin/forms/accounting-posting/contants.ts";

export const useBankTransactionGridProps = ({
  resource,
}: {
  resource: string;
}): Pick<DataGridProps<any>, "onRowClick"> => {
  const router = useRouter();
  if (resource !== ResourceEnum.BankTransaction) {
    return {};
  }

  return {
    onRowClick: (params) => {
      const paths = createModuleRoutePaths({
        resource: ResourceEnum.AccountingPosting,
      });
      const row = params.row as BankTransactionResource;
      if (row?.accounting_posting_positions?.length) {
        const posting_id =
          row?.accounting_posting_positions[0].accounting_posting_id;
        router.navigate(
          replacePathParams(paths.edit.root, {
            id: posting_id,
          }),
        );
      } else if (row.bank_transaction_order?.order_id) {
        const search = new URLSearchParams();
        search.set(
          CreateAccountingPostingFormSearchParams.BankTransactionId,
          row.id,
        );
        search.set(
          CreateAccountingPostingFormSearchParams.ShowAssignOrderForm,
          "true",
        );

        router.navigate(paths.create.root + "?" + search.toString());
      } else {
        const search = new URLSearchParams();
        search.set(
          CreateAccountingPostingFormSearchParams.BankTransactionId,
          row.id,
        );

        // const storageKeys = createResourceStorageKeys({
        //   resource: ResourceEnum.AccountingPosting,
        // });

        // clear unsaved values
        // memoryStorageDriver.remove(
        //   storageKeys.form({
        //     type: "create",
        //   }),
        // );

        router.navigate(paths.create.root + "?" + search.toString());
      }
    },
  };
};
